import {GuideStateApi} from "@repo/guide-state";

/**
 * Remove attached images from the guide state.
 *
 */
export function removeAttachedImagesFromGuideState() {
    const updatedImages = GuideStateApi.latest().images.filter(
        ({interactionID}) => !!interactionID,
    );

    GuideStateApi.set("images", updatedImages);
}
